import { Button, Flex, Table, Tooltip } from "@mantine/core";
import { TagStatus } from "../../../../components";
import { InfoCircle } from "iconsax-react";
import { IResponseHistoryPlans } from "../../../../interfaces/MyPlans/IHistoryPlans";
import { postCancelHistoryPlans } from "../../../../hooks/useMyPlans";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotificationControl } from "../../../../context/notificationContext";
import {
  addDaysToDate,
  convertToDate,
  convertToDateAndHour,
} from "../../../../utils/date";
import { useMediaQuery } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import { colorStatusHistory } from "../../../../utils/StatusHistory";
import { EStatusHistory } from "../../../../interfaces/IQuery";
interface IProps {
  history: IResponseHistoryPlans;
  idProduct: number;
  isDisabled: boolean;
}

export default function TableHistory({
  history,
  idProduct,
  isDisabled,
}: IProps) {
  const { notificationControl } = useNotificationControl();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const isLargerThan1400 = useMediaQuery("(min-width: 1400px)");

  const ths = (
    <tr>
      <th style={{ width: "150px", minWidth: "150px" }}>
        {t(
          "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_history.table.th.data"
        )}
      </th>
      <th
        style={{
          width: isLargerThan1400 ? "auto" : "350px",
          minWidth: isLargerThan1400 ? "auto" : "350px",
        }}
      >
        {t(
          "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_history.table.th.detail"
        )}
      </th>
      <th style={{ width: "180px", minWidth: "150px" }}>
        {t(
          "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_history.table.th.status"
        )}
      </th>
      <th style={{ width: "120px", minWidth: "120px" }}>
        {t(
          "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_history.table.th.effective_from"
        )}
      </th>
      <th style={{ width: "180px", minWidth: "180px" }}>
        {t(
          "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_history.table.th.effective_at"
        )}
      </th>
      <th
        style={{
          width: "130px",
          minWidth: "130px",
        }}
      >
        {t(
          "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_history.table.th.cancel"
        )}
      </th>
    </tr>
  );

  const { mutate: mutateCancel } = useMutation(postCancelHistoryPlans, {
    onSuccess: () => {
      notificationControl({
        title: t(
          "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_history.mutate_cancel.title_success"
        ),
        message: t(
          "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_history.mutate_cancel.message_success"
        ),
        type: "success",
      });
      queryClient.invalidateQueries(["MyPlans"]);
      queryClient.invalidateQueries(["MyHistoryPlans", idProduct]);
    },
    onError: () => {
      notificationControl({
        title: t(
          "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_history.mutate_cancel.title_error"
        ),
        message: t(
          "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_history.mutate_cancel.message_error"
        ),
        type: "danger",
      });
    },
  });

  const handleCancel = (value: number) => {
    mutateCancel({ id: idProduct, idHistory: value });
  };

  return (
    <Flex style={{ overflowX: "auto", width: "auto" }}>
      <Table
        style={{
          tableLayout: isLargerThan1400 ? "fixed" : "auto",
          width: "100%",
        }}
      >
        <thead>{ths}</thead>
        <tbody>
          {history?.data && history?.data?.length > 0 ? (
            history?.data.map((element, index) => {
              const statusInfo = colorStatusHistory(element.status); // Armazene o resultado aqui

              return (
                <tr
                  key={`${element.id}-${index}`}
                  style={{
                    height: "56px !important",
                    minHeight: "56px !important",
                    maxHeight: "56px !important",
                  }}
                >
                  <td
                    style={{
                      width: "200px",
                      minWidth: "200px",
                      height: "56px !important",
                      minHeight: "56px !important",
                      maxHeight: "56px !important",
                    }}
                  >
                    {!!element.created_at
                      ? convertToDateAndHour(element.created_at)
                      : "----"}
                  </td>
                  <td
                    style={{
                      minWidth: "250px !important",
                      height: "56px !important",
                      minHeight: "56px !important",
                      maxHeight: "56px !important",
                    }}
                  >
                    {!!element.action_description
                      ? element.action_description
                      : "----"}
                  </td>
                  <td
                    style={{
                      width: "180px",
                      minWidth: "180px",
                      height: "56px !important",
                      minHeight: "56px !important",
                      maxHeight: "56px !important",
                    }}
                  >
                    <Flex align={"center"} gap="10px">
                      <TagStatus
                        status={statusInfo.color}
                        title={t(statusInfo.title)}
                        border
                      />
                      {element.status === EStatusHistory.Error ||
                      element.status === EStatusHistory.InProcessing ? (
                        <Tooltip label={element.error_message}>
                          <InfoCircle
                            size="24"
                            color="#F43333"
                            variant="Bold"
                          />
                        </Tooltip>
                      ) : null}
                    </Flex>
                  </td>
                  <td
                    style={{
                      width: "200px",
                      minWidth: "200px",
                      height: "56px !important",
                      minHeight: "56px !important",
                      maxHeight: "56px !important",
                    }}
                  >
                    {element.scheduled_at
                      ? convertToDate(element.scheduled_at)
                      : element.status === EStatusHistory.Scheduled
                      ? addDaysToDate(new Date(), 1)
                      : "----"}
                  </td>
                  <td
                    style={{
                      width: "200px",
                      minWidth: "200px",
                      height: "56px !important",
                      minHeight: "56px !important",
                      maxHeight: "56px !important",
                    }}
                  >
                    {!!element.updated_at
                      ? element.updated_at === element.created_at
                        ? "----"
                        : convertToDateAndHour(element.updated_at)
                      : "----"}
                  </td>
                  <td
                    style={{
                      width: "200px",
                      minWidth: "200px",
                      height: "56px !important",
                      minHeight: "56px !important",
                      maxHeight: "56px !important",
                    }}
                  >
                    <Button
                      variant={"dangerOutline"}
                      disabled={!element.is_cancellable || isDisabled}
                      h="41px"
                      onClick={() => handleCancel(element.id)}
                    >
                      {t("global.button.cancel")}
                    </Button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td>----</td>
              <td>----</td>
              <td>----</td>
              <td>----</td>
              <td>----</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Flex>
  );
}
